import {ReactElement} from 'react';
import {CircularProgress, CircularProgressProps} from '@mui/material';

export default function LoadingIcon(props: CircularProgressProps): ReactElement {
  return <CircularProgress {...props} />;
}
